import React from "react";
import { Avatar, Box, Tooltip } from "@mui/material";
import boschIcon from "../assets/images/manufacturer/bosch_icon.png";
import samsungIcon from "../assets/images/manufacturer/samsung_icon.png";
import lionsbotIcon from "../assets/images/manufacturer/lionsbot_icon.png";

// Add a new manufacturer by dropping a logo in assets/images/manufacturer and mapping it here.
const MANUFACTURER_LOGOS = [
  { match: /bosch/i, icon: boschIcon },
  { match: /samsung/i, icon: samsungIcon },
  { match: /lionsbot/i, icon: lionsbotIcon },
];

function resolveManufacturerLogo(manufacturer) {
  return MANUFACTURER_LOGOS.find((entry) => entry.match.test(manufacturer || ""));
}

// Reusable row of manufacturer logos (falls back to initials when no logo is mapped).
export default function DeviceManufacturerStrip({
  manufacturers = [],
  size = 22,
  sx = {},
}) {
  const uniqueManufacturers = Array.from(
    new Set(manufacturers.filter(Boolean)),
  );

  if (uniqueManufacturers.length === 0) {
    return null;
  }

  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: 0.5, ...sx }}>
      {uniqueManufacturers.map((manufacturer) => {
        const logo = resolveManufacturerLogo(manufacturer);
        return (
          <Tooltip key={manufacturer} title={manufacturer}>
            {logo ? (
              <Avatar
                src={logo.icon}
                alt={manufacturer}
                variant="rounded"
                sx={{ width: size, height: size, bgcolor: "transparent" }}
              />
            ) : (
              <Avatar
                variant="rounded"
                sx={{
                  width: size,
                  height: size,
                  fontSize: size * 0.4,
                  bgcolor: "grey.300",
                  color: "text.secondary",
                }}
              >
                {manufacturer.slice(0, 2).toUpperCase()}
              </Avatar>
            )}
          </Tooltip>
        );
      })}
    </Box>
  );
}
